import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {
    chartLading,
    statisticCustomer,
    statisticEmployee,
    statisticLading,
    statisticPartner, statisticRow2, statisticRow3
} from "@/modules/dashboard/services";

@Module({ dynamic: true, name: "dashboard", store })
class DashboardModule extends VuexModule {
    statisticCustomer = [] as any;
    statisticEmployee = [] as any;
    statisticPartner = [] as any;
    statisticLading = [] as any;
    chartLading = [] as any;
    statisticRow2 = [] as any;
    statisticRow3 = [] as any

    @Mutation
    private SET_STATISTIC_CUSTOMER(payload) {
        this.statisticCustomer = payload
    }
    @Mutation
    private SET_STATISTIC_EMPLOYEE(payload) {
        this.statisticEmployee = payload
    }
    @Mutation
    private SET_STATISTIC_PARTNER(payload) {
        this.statisticPartner = payload
    }

    @Mutation
    private SET_STATISTIC_LADING(payload) {
        this.statisticLading = payload
    }

    @Mutation
    private SET_CHART_LADING(payload) {
        this.chartLading = payload
    }

    @Mutation
    private SET_STATISTIC_ROW2(payload) {
        this.statisticRow2 = payload
    }
    @Mutation
    private SET_STATISTIC_ROW3(payload) {
        this.statisticRow3 = payload
    }

    @Action({ rawError: true })
    public async getStatisticCustomer(params: any) {
        const { data } = await statisticCustomer(params);
        this.SET_STATISTIC_CUSTOMER(data.datas);
    }

    @Action({ rawError: true })
    public async getStatisticEmployee(params: any) {
        const { data } = await statisticEmployee(params);
        this.SET_STATISTIC_EMPLOYEE(data.datas);
    }

    @Action({ rawError: true })
    public async getStatisticPartner(params: any) {
        const { data } = await statisticPartner(params);
        this.SET_STATISTIC_PARTNER(data.datas);
    }

    @Action({ rawError: true })
    public async getStatisticLading(params: any) {
        const { data } = await statisticLading(params);
        this.SET_STATISTIC_LADING(data.datas);
    }

    @Action({ rawError: true })
    public async getChartLading(params: any) {
        const { data } = await chartLading(params);
        this.SET_CHART_LADING(data.datas);
    }

    @Action({rawError: true})
    public async getStatisticRow2(params: any) {
        debugger
        const  { data } = await statisticRow2(params);
        console.log("bao cao...", data.datas)
        this.SET_STATISTIC_ROW2(data.datas);
    }
    @Action({rawError: true})
    public async getStatisticRow3() {
        const  { data } = await statisticRow3();
        console.log("data = ", data)
        return data.datas
    }
}

export const DashboardStore = getModule(DashboardModule);
